<template>
  <div>

    <a  @click="fnShowModal()" class="p-2"><i class="far fa-edit text-primary"></i></a>

    <b-modal ref="modal" hide-footer title="Vehicle category">
        <div class="d-block">
          <form>

            <div class="form-group">
              <label for="category">Category</label>
              <input type="text" 
              class="form-control" 
              id="category" 
              placeholder="Category"
              v-model="category">
              <div class="invalid-feedback" v-if="errors.category">{{ errors.category[0] }}</div>
            </div>
            <div class="form-group">
                <label for="fuelFlatRate">Fuel flat rate</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="fuelFlatRate" 
                placeholder="Fuel flat rate"
                v-model="fuelFlatRate">
                <div class="invalid-feedback" v-if="errors.fuelFlatRate">{{ errors.fuelFlatRate[0] }}</div>
            </div>
             <div class="form-group">
                <label for="unleadedPetrolCostPerKM">Unleaded petrol cost/Km</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="unleadedPetrolCostPerKM" 
                placeholder="Unleaded petrol cost/Km"
                v-model="unleadedPetrolCostPerKM">
                <div class="invalid-feedback" v-if="errors.unleadedPetrolCostPerKM">{{ errors.unleadedPetrolCostPerKM[0] }}</div>
            </div>
            <div class="form-group">
                <label for="premiumUnleadedCostPerKM">Premium unleaded cost/Km</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="premiumUnleadedCostPerKM" 
                placeholder="Premium unleaded cost/Km"
                v-model="premiumUnleadedCostPerKM">
                <div class="invalid-feedback" v-if="errors.premiumUnleadedCostPerKM">{{ errors.premiumUnleadedCostPerKM[0] }}</div>
            </div>
             <div class="form-group">
                <label for="dieselCostPerKM">Diesel cost/KM</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="dieselCostPerKM" 
                placeholder="Diesel cost/Km"
                v-model="dieselCostPerKM">
                <div class="invalid-feedback" v-if="errors.dieselCostPerKM">{{ errors.dieselCostPerKM[0] }}</div>
            </div>
            <div class="form-group">
                <label for="tyresCostPerKM">Tyres cost/Km</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="tyresCostPerKM" 
                placeholder="Tyres cost/Km"
                v-model="tyresCostPerKM">
                <div class="invalid-feedback" v-if="errors.tyresCostPerKM">{{ errors.tyresCostPerKM[0] }}</div>
            </div>
            <div class="form-group">
                <label for="serviceCostPerKM">Maintenance cost / Km</label>
                <input type="number" 
                step="any"
                class="form-control" 
                id="serviceCostPerKM" 
                placeholder="Maintenance cost/Km"
                v-model="serviceCostPerKM">
                <div class="invalid-feedback" v-if="errors.serviceCostPerKM">{{ errors.serviceCostPerKM[0] }}</div>
            </div>

            
           <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                >
                Status
            </b-form-checkbox>
          <hr>
          <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button  type="button" @click="fnUpdate()" class="btn btn-success btn-sm">Update</button>
          </div>
          </form>
        </div>
      </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as vehicleCategoryService from '../../services/vehicleCategory.service';
    export default {
        name:"ModelVehicleCategoryEdit",
        props:['propsData'],
        components: {
            
        },
        data(){
            return{
                errors:{},
                id:'',
                category:'',
                fuelFlatRate:'',
                unleadedPetrolCostPerKM:'',
                premiumUnleadedCostPerKM:'',
                dieselCostPerKM:'',
                tyresCostPerKM:'',
                serviceCostPerKM:'',
                status:'',
            }
        },
        computed:{
            ...mapGetters(['gettVehicleCategoryAll']),
        },
        methods:{
            ...mapActions(['fetchVehicleCategoryAll']),
            fnShowModal(){
                this.fnGetValue(this.propsData)
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            fnGetValue(props){
                this.id = props.rowData.id;
                this.status = props.rowData.status;
                this.category = props.rowData.category;
                this.fuelFlatRate  = props.rowData.fuelFlatRate;
                this.unleadedPetrolCostPerKM  = props.rowData.unleadedPetrolCostPerKM;
                this.premiumUnleadedCostPerKM  = props.rowData.premiumUnleadedCostPerKM;
                this.dieselCostPerKM  = props.rowData.dieselCostPerKM;
                this.tyresCostPerKM = props.rowData.tyresCostPerKM;
                this.serviceCostPerKM = props.rowData.serviceCostPerKM;
            },

            fnUpdate:async function(){
                const obj = {
                    "category":this.category,
                    "fuelFlatRate":this.fuelFlatRate,
                    "unleadedPetrolCostPerKM":this.unleadedPetrolCostPerKM,
                    "premiumUnleadedCostPerKM": this.premiumUnleadedCostPerKM,
                    "dieselCostPerKM": this.dieselCostPerKM,
                    "tyresCostPerKM":this.tyresCostPerKM,
                    "serviceCostPerKM":this.serviceCostPerKM,
                    "status":this.status
                }

                try{
                    await vehicleCategoryService.update(this.id, obj);
                    this.fetchVehicleCategoryAll();
                    messageService.fnSweetAlertSuccessToast('Vehicle category', 'Updated successfully ');
                    this.hideModal();

                    this.id = ''; 
                    this.category = '';
                    this.fuelFlatRate = '';
                    this.unleadedPetrolCostPerKM = '';
                    this.premiumUnleadedCostPerKM = '';
                    this.dieselCostPerKM = '';
                    this.tyresCostPerKM = '';
                    this.serviceCostPerKM = '';
                    this.status ='';
                }catch(error){
                    messageService.fnSweetAlertErrorToast('Vehicle category - update', error.response.data.message);
                }
            }
        }
    }
</script>